import { render, staticRenderFns } from "./UserLevel.vue?vue&type=template&id=2441e4c3&scoped=true"
import script from "./UserLevel.vue?vue&type=script&lang=js"
export * from "./UserLevel.vue?vue&type=script&lang=js"
import style0 from "./UserLevel.vue?vue&type=style&index=0&id=2441e4c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2441e4c3",
  null
  
)

export default component.exports